import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { PERMISSIONS } from '@/lib/rbac'
import { Staff } from '@/features/staff'

// Search params schema for staff table
const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  username: z.string().optional().catch(undefined),
  status: z.array(z.string()).optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/staff/')({
  validateSearch: searchSchema,
  beforeLoad: async () => {
    const { auth } = useAuthStore.getState()

    // Check if user has permission to view staff
    if (!auth.canAccess([PERMISSIONS.STAFF.READ])) {
      throw redirect({
        to: '/unauthorized',
      })
    }
  },
  component: Staff,
})
